export default function HowItWork() {
  return (
    <>
      <section className="section" id="how-it-works">
        <div className="container">
          <p className="section-eyebrow">Simple &amp; fast</p>
          <h2 className="section-title">How RouteRider works</h2>
          <p className="section-sub">
            Three easy steps between you and your next trip.
          </p>
          <div className="steps-grid">
            <div className="step-card reveal in">
              <img
                src="/assets/website/images/step-search.svg"
                alt="Search your route"
              />
              <h3>1. Search your route</h3>
              <p>
                Enter your from &amp; to city, pick a travel date and choose how
                many seats you need.
              </p>
            </div>
            <div className="step-card reveal in">
              <img
                src="/assets/website/images/step-choose.svg"
                alt="Choose seat or cab"
              />
              <h3>2. Choose your ride</h3>
              <p>
                Pick per-seat sharing to save money, or book the full cab for
                privacy and flexibility.
              </p>
            </div>
            <div className="step-card reveal in">
              <img src="/assets/website/images/step-book.svg" alt="Book and travel" />
              <h3>3. Book &amp; travel</h3>
              <p>
                Confirm instantly, track your verified driver live, and pay a
                fixed, upfront fare.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
